import React, {useState} from 'react';
import classes from "./referrals.module.css";
import {CSSTransition} from "react-transition-group";

const Referrals = ({isOpen, setIsOpen, data}) => {
    const [level, setLevel] = useState(1)

    return (
        <>
            <CSSTransition in={isOpen}
                           timeout={300}
                           classNames="openBlock"
                           unmountOnExit>
                <div className={classes.fon} onClick={()=>setIsOpen(false)}></div>
            </CSSTransition>
            <CSSTransition in={isOpen}
                           timeout={300}
                           classNames="openBonusMenu"
                           unmountOnExit>
                <div className={classes.block2}>
                    <div className={classes.close} onClick={()=>setIsOpen(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M11.9997 10.5865L16.2424 6.34382C16.6329 5.9533 17.2661 5.9533 17.6566 6.34382C18.0471 6.73435 18.0471 7.36751 17.6566 7.75803L13.4139 12.0007L17.6566 16.2433C18.0471 16.6338 18.0471 17.267 17.6566 17.6575C17.2661 18.048 16.6329 18.048 16.2424 17.6575L11.9997 13.4149L7.75706 17.6575C7.36654 18.048 6.73338 18.048 6.34286 17.6575C5.95233 17.267 5.95233 16.6338 6.34286 16.2433L10.5855 12.0007L6.34285 7.75804C5.95232 7.36751 5.95233 6.73435 6.34285 6.34382C6.73338 5.9533 7.36654 5.9533 7.75707 6.34383L11.9997 10.5865Z" fill="white"/>
                        </svg>
                    </div>
                    <div className={classes.text1}>Приглашенные друзья</div>
                    <div className={classes.block}>
                        <div className={classes.levels}>
                            <div className={classes.level} style={{borderRadius:'10px 0 0 10px', opacity:level===1?1:0.5}} onClick={()=>setLevel(1)}>1 уровень</div>
                            <div className={classes.level} style={{opacity:level===2?1:0.5}}  onClick={()=>setLevel(2)}>2 уровень</div>
                            <div className={classes.level} style={{borderRadius:'0 10px 10px 0', opacity:level===3?1:0.5}} onClick={()=>setLevel(3)}>3 уровень</div>
                        </div>
                        <div className={classes.data}>
                            <div className={classes.item} style={{paddingRight:'12px',borderBottom:"1px solid white"}}>
                                <div className={classes.name}>Всего: {data['level'+level]?.length}</div>
                                <div className={classes.name}>{data['level'+level]?.reduce((accumulator, currentProduct) => {
                                    return accumulator + currentProduct.for_ref_balance;
                                }, 0)} ₽</div>
                            </div>
                            <div className={classes.item} style={{padding:0, borderBottom:"1px solid white"}}>
                                <div className={classes.name}>Пользователь</div>
                                <div className={classes.name}>Доход ₽</div>
                            </div>
                            {data && data['level'+level]?.map(item=>
                                <div className={classes.item} key={item.id}>
                                    <div className={classes.item2}>
                                        <div className={classes.avatarBlock}>
                                            {item.telegram_avatar ? <img alt={''} src={item.telegram_avatar} className={classes.avatar}/>
                                                : <div>{item.telegram_name && item.telegram_name.slice(0,1)}</div>}
                                        </div>
                                        <div className={classes.name}>{item.telegram_name}</div>
                                    </div>
                                    <div className={classes.name}>{item.for_ref_balance}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </>
    );
};

export default Referrals;